const MULTIPLIER_OPTIMAL = 0.8913

export const resize = (value: number | undefined) => (value === undefined ? undefined : value * MULTIPLIER_OPTIMAL)
